
import Storage from "@/utils/storage.js"
import api from "@/request/api"
import router from '@/router'
import { Post,Put } from "@/request/index.js"
const state = {
  token: Storage.getItem("token"),
  userInfo: Storage.getItem("userInfo"),
  isLoginMode:true,
  baseUrl: process.env.VUE_APP_BASE_API_URL+ "/"+(process.env.VUE_APP_BASE_API_URL=='https://sp.timedg.com'?'':'api/'),
}
const mutations = {
  setToken(state, token) {
    state.token = token,
    Storage.setItem("token", token)
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
    Storage.setItem("userInfo",userInfo)
  },
  resetAll(state) {
    state.token = "",
    state.userInfo = ""
    Storage.removeAll()
  },
  setIsLoginMode(state,value){
    state.isLoginMode = value
  }
}
const actions = {
  //登录接口
  async login(context, data){
    const {api,formData} = data
    const res = await Post(api,formData, false)
    context.commit('setToken', res.token)
    context.commit('setUserInfo', res.user)
    Storage.setTimeStamp() 
  },
  //返回图片路径前缀
  getImageUrl({ commit }) {
    context.commit('setToken', res)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



